import React, { useContext } from 'react';
import { i18n as I18n, withTranslation } from '../utils/i18n';

// context
import { AuthContext } from '../state/auth';

// components
import Page from '../components/page';
import LoginActionPanel from '../components/loginActionPanel';
import ResetPasswordForm from '../components/forms/resetPassword';

const ResetPasswordPage = () => {
  const { actions } = useContext(AuthContext);

  const resetPassword = async (
    { email },
    { setSubmitting = () => {} } = {}
  ) => {
    await actions.resetPassword(email);
    setSubmitting(false);
  };

  const heading = I18n.t('reset_password.heading');

  return (
    <Page title={heading}>
      <LoginActionPanel
        heading={heading}
        showResetPasswordLink={false}
        showRegisterLink={false}
        showResendConfirmationLink={false}
      >
        <ResetPasswordForm onSubmit={resetPassword} />
      </LoginActionPanel>
    </Page>
  );
};

ResetPasswordPage.getInitialProps = async () => ({
  namespacesRequired: ['common'],
});

export default withTranslation('common')(ResetPasswordPage);
